import React from 'react';
import { useTasksGroupsFilterService } from 'features/tasks-forms';
import BorderedBox from '../../../../shared/web/layout/BorderedBox';
import { CheckboxGroup, FormTemplate, Header5, Right, SimpleBlock, Text } from 'ui-builder';
import { createPortal } from 'react-dom';

import styles from './AssigneeFilter.module.scss';
import { TasksGroupIcon } from 'features/nekst-widgets';
import { ToggledFeature, withToggleWrapper } from 'feature-toggle';
import {
  SelectAllFilterOptionsCheckbox,
  SelectAllFilterOptionsCheckboxPortal
} from "../../../../shared/widgets/SelectAllFilterOptionsCheckbox";

export function TasksGroupFilterContainer() {
  return (
    <div id={'tasksGroupFilter'}></div>
  );
}

export function TasksGroupsCheckboxGroup() {
  const tasksGroupsFilterService = useTasksGroupsFilterService();

  const options = tasksGroupsFilterService.getOptions()
    .map((o) => ({
      ...o,
      label: <TasksGroupIcon group={o._data!} withName />
    }));

  if (options.length) {
    return (
      <>
        <CheckboxGroup
          options={options}
          value={tasksGroupsFilterService.getFilterValue()}
          source="tasksGroupsIds"
          isDisabled={options.length === 1}
          hideLabel
        />
        <SelectAllFilterOptionsCheckbox
          allOptions={options.map((o) => o.value)}
          source="tasksGroupsIds"
        />
      </>

    );
  } else {
    return <Text>-</Text>;
  }

}

export function TasksGroupFilterForm() {
  const tasksGroupsFilterService = useTasksGroupsFilterService();

  return (
    <>
      <SimpleBlock>
        <Right>
          <SelectAllFilterOptionsCheckboxPortal source="tasksGroupsIds" />
        </Right>
        <Header5>Groups</Header5>
      </SimpleBlock>

      <FormTemplate<{ tasksGroupsIds: number[] }>
        submitFormFunc={async (data) => {
          tasksGroupsFilterService.setFilterValue(data.tasksGroupsIds);
          return data;
        }}
        submitOnEachChange
        buttons={null}
      >
        <TasksGroupsCheckboxGroup />
      </FormTemplate>
    </>
  );
}

function TasksGroupFilter() {

  const container = document.getElementById('tasksGroupFilter');

  if (container) {
    return createPortal(
      <BorderedBox title="Groups" className={styles.filter}>
        <TasksGroupFilterForm />
      </BorderedBox>,
      container
    );
  } else {
    return null;
  }
}

export default withToggleWrapper(TasksGroupFilter, ToggledFeature.TASKS_GROUPS);
